import { IsoDate } from "../dates"
import { Uuid } from "../uuid"

interface Segmentable {
  // [TODO:TS] Refine type
  segment?: object | null
}

export interface SelectedPortfolio extends Segmentable {
  type: "PORTFOLIO"
  id: Uuid
  experimentId?: undefined
}

// [TODO:TS] Should we make that type: "EXPERIMENT" instead?
export interface SelectedExperiment extends Segmentable {
  type: "PORTFOLIO"
  id: Uuid
  experimentId: string // short ID
}

export interface SelectedEtf extends Segmentable {
  type: "ETF"
  id: string // internal id
}

export interface SelectedBasket extends Segmentable {
  type: "BASKET"
  id: string // ticker
}

export interface SelectedBenchmark extends Segmentable {
  type: "BENCHMARK"
  id: string
}

export interface SelectedIndex extends Segmentable {
  type: "INDEX"
  id: string
}

interface PositionSetAsset {
  economicExposure: number
  attributes: object | null
  lotId: string | null
}

export interface PositionSetEquity extends PositionSetAsset {
  id: {
    bloombergTicker: string | null
    figi: string | null
    internalId: string
    mic: string
    modelProviderId: string
    ticker: string
  }
}

export interface PositionSetOtherAsset extends PositionSetAsset {
  id: string
}

export interface SelectedInlineInstrumentDate {
  date: IsoDate
  equities: PositionSetEquity[]
  swaps: PositionSetOtherAsset[]
  currencies: PositionSetOtherAsset[]
  fixedIncome: PositionSetOtherAsset[]
  commodities: PositionSetOtherAsset[]
  otherAssets: PositionSetOtherAsset[]
  indexes: PositionSetOtherAsset[]
}

export interface SelectedInlineInstrument extends Segmentable {
  type: undefined
  id: undefined
  name?: string
  dates: SelectedInlineInstrumentDate[]
}

export enum WeightingGroupingType {
  LONG_SHORT = "LONG_SHORT",
}

interface PositionSetEqualWeightingInput {
  groupBy?: WeightingGroupingType
}

export interface PositionSetWeightingRule {
  equalWeighting?: PositionSetEqualWeightingInput
}

export interface SelectedRulesInstrument extends Segmentable {
  type: "RULES"
  id: undefined
  rulesConfiguration: {
    source: {
      positionSet: SelectedTypedInstrument
    }
    rules: {
      weighting: PositionSetWeightingRule
    }[]
  }
}

export type SelectedTypedInstrument = SelectedPortfolio | SelectedExperiment | SelectedEtf | SelectedBasket | SelectedBenchmark | SelectedIndex
export type SelectedInstrument = SelectedTypedInstrument | SelectedInlineInstrument | SelectedRulesInstrument
